/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drawer_SearchInputs */

const en_drawer_search = /** @type {(inputs: Drawer_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search plans…`)
};

const id_drawer_search = /** @type {(inputs: Drawer_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari rencana…`)
};

/**
* | output |
* | --- |
* | "Search plans…" |
*
* @param {Drawer_SearchInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const drawer_search = /** @type {((inputs?: Drawer_SearchInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drawer_SearchInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_drawer_search(inputs)
	return en_drawer_search(inputs)
});